import { render, staticRenderFns } from "./original.vue?vue&type=template&id=b98e73f2"
import script from "./original.vue?vue&type=script&lang=js"
export * from "./original.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports